import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import axios from '@/plugins/axios'
import vuetify from '@/plugins/vuetify'
import clipboard from '@/plugins/clipboard'
import uploader from '@/plugins/uploader'
import vueHeadful from 'vue-headful'
import lingallery from 'lingallery'
import vuelidate from '@/plugins/vuelidate'

Vue.config.productionTip = false
Vue.prototype.$can = store.getters['auth/can']

Vue.component('lingallery', lingallery)
Vue.component('vue-headful', vueHeadful)

new Vue({
  router,
  store,
  vuetify,
  axios,
  uploader,
  clipboard,
  vuelidate,
  render: h => h(App)
}).$mount('#app')
